"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterValues = /** @class */ (function () {
    function FilterValues() {
    }
    return FilterValues;
}());
exports.FilterValues = FilterValues;
;
